import { useEffect } from "react";
import api from "api";
import { useState } from "react";
import 'styles/quotelist.css';
import QuoteItem from 'components/quoteComponents/QuoteItem';

// affiche la liste des équipements devisés dans une sous catégorie ainsi que leur nombre 
const QuoteItems = (
    {
        subCategory, // une sous catégorie
        quoteid, // numéro du devis
        setObjectToReload, // initialise un équipement à recharger
        reloadedSubCategory, // flag sous categorie rechargée
        reload, // rechargement d'un équipement du devis
        dataToReload, // données sur l'équipement à recharger
        group, // groupe sélectionné
    }
) => {

    const [ quoteitems, setQuoteitems ] = useState([]); // liste des équipements devisés de la sous catégorie
    const [firstLoad, setFirstLoad] = useState(true); // flag pour le premier chargement

    // récupère la liste de matériel
    useEffect(() => {
        if (firstLoad || (reload && dataToReload.subCategory_id === subCategory.id))
        { 
            const group_id = (group ? group.id : 0);
            api.get(`quote/${quoteid}/subcategory/${subCategory.id}/group/${group_id}/items`)
            .then(response => {
                setQuoteitems(response.data);
                if (firstLoad) setFirstLoad(false);
                if (reload) reloadedSubCategory();
            });
        }
      }, [firstLoad,quoteid,subCategory.id, reloadedSubCategory, reload, dataToReload.subCategory_id, group]);

    return(
        quoteitems.map((i) => <QuoteItem
            key={i.id}
            quoteitem={i} // équipement
            setObjectToReload={setObjectToReload} // initialise un équipement à recharger
        />)
    );
}

// affiche une sous catégorie et le nombre de matériel de cette sous catégorie devisé dans le devis 
const QuoteSubCategory = (
    {
        subCategory, // une sous catégorie
        quoteid, // numéro du devis
        reload, // rechargement d'un équipement du devis
        setObjectToReload, // initialise un équipement à recharger
        reloadedSubCategory, // flag sous categorie rechargée
        dataToReload, // données sur l'équipement à recharger
        group // groupe sélectionné
    }
) => {

    const [nbItems, setNbItems] = useState(0); // nombe de matériel devisé dans la sous-catégorie
    const [hidden, setHidden] = useState(true); // flag pour le masquage de la liste de matériel devisé
    const [firstLoad, setFirstLoad] = useState(true); // flag pour le premier chargement
    
    // récupère le nombre de matériel devisé
    useEffect(() => {
        if ((reload && dataToReload.subCategory_id === subCategory.id ) || firstLoad)
        {   
            const group_id = (group ? group.id : 0);
            api.get(`quote/${quoteid}/subcategory/${subCategory.id}/group/${group_id}`)
            .then(response => {
                setNbItems(response.data.quantity);
                setHidden(response.data.quantity===0);
                if (firstLoad) setFirstLoad(false);
            });
        }
      }, [dataToReload.subCategory_id, firstLoad, quoteid, reloadedSubCategory, reload, subCategory.id, group]);

    // gère le clic pour dérouler la liste de matériel
    const handleClick = () => {
        if (nbItems) setHidden(!hidden);
    }
    
    return(
        <>
            <div
                className="QuoteSubCategory"
                onClick={handleClick}
            >
                {subCategory.name} ({nbItems})
            </div>
            {
                !hidden
                &&
                <QuoteItems
                    subCategory = {subCategory}
                    quoteid = {quoteid}
                    reload={reload} // rechargement d'un équipement du devis
                    setObjectToReload={setObjectToReload} // initialise un équipement à recharger
                    dataToReload={dataToReload} // données sur l'équipement à recharger
                    reloadedSubCategory={reloadedSubCategory} // flag sous categorie rechargée
                    group={group} // groupe sélectionné
                />
            }
        </>
    );
}

// affiche une catégorie et le nombre de matériel de cette catégorie devisé dans le devis 
const QuoteCategory = (
    {
        category, // une catégorie
        quoteid, // numéro du devis
        reload, // rechargement d'un équipement du devis
        setObjectToReload, // initialise un équipement à recharger
        reloadedCategory, // flag catégorie rechargée
        reloadedSubCategory, // flag sous categorie rechargée
        dataToReload, // données sur l'équipement à recharger
        group, // groupe sélectionné
    }
) => {

    const [nbItems, setNbItems] = useState(0); // nombe de matériel devisé dans la catégorie
    const [hidden, setHidden] = useState(true); // flag pour le masquage des sous catérogies
    const [firstLoad, setFirstLoad] = useState(true); // flag pour le premier chargement

    // récupère le nombre de matériel devisé
    useEffect(() => {
        if ((reload && dataToReload.category_id === category.id) || firstLoad || group)
        {
            const group_id = (group ? group.id : 0);
            api.get(`quote/${quoteid}/category/${category.id}/group/${group_id }`)
            .then(response => {
                setNbItems(response.data.quantity);
                setHidden(response.data.quantity===0);
                if (firstLoad) setFirstLoad(false);
                if (reload) reloadedCategory();
            });
        }
      }, [category.id, dataToReload.category_id, firstLoad, reload, quoteid, reloadedCategory, group]);

    // gère le clic pour dérouler les sous catégorie
    const handleClick = () => {
        setHidden(!hidden);
    }
    
    return(
        <>
            <div
                className="QuoteCategory"
                onClick={handleClick}
            >
                {category.name} ({nbItems})
            </div>
            {
                !hidden
                &&
                category.subcategories.map((sb) => <QuoteSubCategory
                    key = {sb.id}
                    subCategory = {sb}
                    quoteid = {quoteid}
                    reload={reload} // rechargement d'un équipement du devis
                    setObjectToReload={setObjectToReload} // initialise un équipement à recharger
                    reloadedSubCategory={reloadedSubCategory} // flag sous categorie rechargée
                    dataToReload={dataToReload} // données sur l'équipement à recharger
                    group={group} // groupe sélectionné
                />)
            }
        </>
    );
}

// affiche une ligne d'un groupe sélectionnable
const QuoteGroupLine = (
    {
        group,
        setGroup,
        selectedGroup,
    }
) => {

    const handleClick = () => {
        setGroup(group);
    };
    
    return (
        <div
            className={ 
                `QuoteListGroupLine
                ${selectedGroup && group.id === selectedGroup.id && "QuoteListGroupLineSelected"}
            `}
            onClick={handleClick}
        >
            {group.name}
        </div>
    );
};

// affiche la liste des catégories
const QuoteList = (
    {
        categories, // liste des catégories
        quoteid, // numéro du devis
        reload, // rechargement d'un équipement du devis
        setObjectToReload, // initialise un équipement à recharger
        reloadedCategory, // flag catégorie rechargée
        reloadedItem, // flag équipement rechargé
        reloadedSubCategory, // flag sous categorie rechargée
        dataToReload, // données sur l'équipement à recharger
        groups, // liste des groupes
        group, // groupe sélectionné
        setGroup, // pour sélectionner un groupe
    }
) => {

    return(
        <>  
            {
                groups.map((g) => 
                    <QuoteGroupLine
                        key={g.id}
                        group={g}
                        setGroup={setGroup}
                        selectedGroup={group}
                    />)
            }
            {
                ( (group) || (groups.length===0) )
                &&
                categories.map((c) => <QuoteCategory 
                    key={c.id}
                    category={c} 
                    quoteid={quoteid}
                    reload={reload} // rechargement d'un équipement du devis
                    setObjectToReload={setObjectToReload} // initialise un équipement à recharger
                    reloadedCategory={reloadedCategory} // flag catégorie rechargée
                    reloadedItem={reloadedItem} // flag équipement rechargé
                    reloadedSubCategory={reloadedSubCategory} // flag sous categorie rechargée
                    dataToReload={dataToReload} // données sur l'équipement à recharger
                    group={group} // groupe sélectionné
                />)
            }
        </>
    );
};

export default QuoteList;